<util-progress *ngIf="loading" [bar]="true"></util-progress>
<div class="row">
  <div class="col-xl-12">
    <div class="card">
      <div class="card-body">
        <h4 class="card-title mb-4">Create/Update File</h4>
        <form [formGroup]="fileForm">

          <app-image-uploader-v2
            title="{{translations['Select File']}}"
            [multiSelect]="true"
            [images]="getExImages()"
            [required]="true"
            (onUploaded)="onImgUploaded($event)"
          ></app-image-uploader-v2>

          <div class="d-flex flex-wrap gap-3 float-end">
            <button class="btn btn-secondary waves-effect" (click)="onCancel()">
              Cancel
            </button>
            <button type="submit" class="btn btn-primary waves-effect waves-light"
                    [ngClass]="fileForm.valid?'':'disabled'" (click)="onSubmit()">
              Submit
            </button>
          </div>
        </form>
      </div>
      <!-- end card body -->
    </div>
    <!-- end card -->
  </div>
</div>

